<div class="container">

  <div class="text-center" *ngIf="loading">
    <img src="assets/loading.gif">
  </div>
  <div class="product-details-container" *ngIf="!loading">
    <div class="product-images-container" *ngIf="this.product !== null && this.product.images.isNotEmpty()">
      <div id="productImagesCarousel" class="carousel slide product-images-slider" data-bs-ride="true"
           *ngIf="product !== null">
        <div class="carousel-indicators">
          <div *ngFor="let image of this.product?.images; index as i">
            <button type="button" data-bs-target="#productImagesCarousel" [attr.data-bs-slide-to]="i"
                    [class.active]="i === 0" [attr.aria-current]="i === 0 ? 'true' : null"
                    [attr.aria-label]="'Slide ' + (i + 1)"></button>
          </div>
        </div>
        <div class="carousel-inner product-image-inner">
          <div *ngFor="let image of this.product?.images; index as i" class="carousel-item product-image"
               [class.active]="i === 0" data-bs-interval="5000">
            <img (error)="setDefaultPlaceholder(i)" [src]="productImages[i]" class="d-block w-100">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#productImagesCarousel"
                data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#productImagesCarousel"
                data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>

    <div *ngIf="this.productImages.isEmpty() && this.product?.thumbnailURL !== null" class="product-image-placeholder">
      <img [src]="product?.thumbnailURL">
    </div>

    <div *ngIf="this.productImages.isEmpty() && !this.product?.thumbnailURL" class="product-image-placeholder">
      <img src="assets/product-placeholder.svg">
    </div>

    <div class="product-info">
      <div *ngIf="product !== null">
        <div class="my-1">
          <div class="d-inline-block">
            <a class="merchant-a" (click)="viewMerchant()">
              <img class="merchant-image" [src]="product.merchant?.profilePictureURL || 'assets/merchant-placeholder.svg'" />
              <p>{{ product.merchant?.name }}</p>
            </a>
          </div>
        </div>
        <h1>{{ product!.name }}</h1>

        <div class="category">
          <p>{{ product.category?.name }}</p>
        </div>
        <p>{{ product!.description }}</p>
        <div class="price">
          <p i18n="@@priceCurrency">{{ product!.price / 100 }} EGP</p>
        </div>
      </div>
      <div class="product-cooking-state">
        <div class="cooking-state">
          <img src="assets/product-ready-within-icon.svg">
          <div>
            <div class="state-title">
              <p i18n="@@readyWithin">Ready Within</p>
            </div>
            <div class="state-value">
              <p>{{ getReadyWithinState() }}</p>
            </div>
          </div>
        </div>
        <div class="cooking-state">
          <img src="assets/product-cooked-state-icon.svg">
          <div>
            <div class="state-title">
              <p i18n="@@mealStatus">Meal Status</p>
            </div>
            <div class="state-value">
              <p>{{ getState() }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="product-review-container"
       *ngIf="this.ratingApiResponse !== null && this.ratingApiResponse.data.isNotEmpty()">
    <div class="overall-title">
      <p i18n="@@overallRating">Overall Rating</p>
    </div>
    <div class="product-overall-rating-content">
      <div>
        <img src="assets/star-icon.svg">
      </div>
      <div class="overall-rate-container">
        <div class="overall-rate">
          <p>{{ getAverageRating() }}</p>
        </div>
        <div class="number-of-reviews">
          <p i18n="@@basedOn">Based on {{ numberOfReviews }} reviews</p>
        </div>
      </div>
      <div class="write-review-button" *ngIf="customerLoggedIn">
        <primary-button title="{{reviewLabel}}" (onClick)="writeReview()"></primary-button>
      </div>
    </div>
    <div class="reviews-container">
      <div class="customer-review-item-container" *ngFor="let rating of ratingApiResponse?.data">
        <div class="customer-review-details">
          <div class="customer-image">
            <img [src]="getImageAvatar(rating)">
          </div>
          <div class="customer-review-info">
            <div class="customer-name">
              <p>{{ rating.commenter.name }}</p>
            </div>
            <div class="customer-review-date">
              <p>{{ rating.createdAt | date : 'dd MMM yyyy' }}</p>
            </div>
          </div>
          <div class="customer-rate">
            <img [src]="rating.rating >= 1 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
            <img [src]="rating.rating >= 2 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
            <img [src]="rating.rating >= 3 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
            <img [src]="rating.rating >= 4 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
            <img [src]="rating.rating >= 5 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
          </div>
        </div>
        <div class="customer-review-content">
          <p>{{ rating.comment }}</p>
        </div>

        <div class="d-flex" *ngIf="showRemoveBtn(rating)">
          <div class="remove-btn clickable" (click)="onRemoveRate(rating)">
            <span *ngIf="!isRemoveRateLoading" i18n="@@Remove">Remove</span>
            <div *ngIf="isRemoveRateLoading" class="spinner-container">
              <div class="spinner-border text-white" role="status">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>


  <div class="empty-reviews-container" *ngIf="this.ratingApiResponse === null || this.ratingApiResponse.data.isEmpty()">

    <h1 class="title-section-rate" i18n="@@ratingsAndReviews">Ratings and Reviews</h1>
    <div><img src="assets/review-empty-state.svg"></div>
    <div class="empty-state-title">
      <p i18n="@@emptyRateTitle">No ratings yet</p>
    </div>
    <div class="empty-state-message">
      <p i18n="@@emptyRateSubtitle">Be the first to share your experience!</p>
    </div>
    <div class="empty-review-button" *ngIf="customerLoggedIn">
      <primary-button [title]="reviewLabel" (onClick)="writeReview()"></primary-button>
    </div>
  </div>

  <div class="extra-content-container" *ngIf="recommendedProducts.length > 0">
    <h1 i18n="@@relatedDishes">Related dishes 🥗</h1>
    <div class="related-content">
      <product-item *ngFor="let product of recommendedProducts" [product]="product"></product-item>
    </div>
  </div>
  <div class="extra-content-container" *ngIf="recommendedMerchants.length > 0">
    <h1 i18n="@@exploreMoreRest">Explore more restaurants 👩‍🍳</h1>
    <div class="related-content">
      <merchant-list-item *ngFor="let merchant of recommendedMerchants" [merchant]="merchant"></merchant-list-item>
    </div>
  </div>
</div>
